export default "__VITE_ASSET__DSMCTeS4__"